
import Misc from './Misc';
import Forms from './Forms';
import Icons from './icons';

export default  {
	Misc,
	Forms,
	Icons
};